<template>
    <div class="toggle toggle-primary">
        <section :class="{ 'toggle': true, 'active': active }">
            <label :class="{ 'disabled': !enabled }"  @click="toggle" >
                <slot name="header"></slot>
            </label>
            <div class="toggle-content" :style="{ 'display': active ? 'block' : 'none' }">
                <slot name="content"></slot>
                <div class="pull-right" style="padding: 10px;" v-if="hasNext">
                    <button class="btn btn-success" @click="goToNext" :disabled="nextDisabled">{{ $t('common.actions.next') }}</button>
                </div>
            </div>
        </section>
    </div>
    
</template>


<script>
export default {
    name: 'Accordion',
    props: {
        value: {
            type: Boolean,
            required: false,
            default: true
        },
        enabled: {
            type: Boolean,
            required: false,
            default: true
        },
        nextDisabled: {
            type: Boolean,
            required: false,
            default: false
        },
        hasNext: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    computed: {
        active: {
            get() {
                return this.value;
            }, set(val) {
                this.$emit('input', val);
            }
        }
    },
    methods: {
        toggle: function() {
            if (this.enabled) {
                this.active = !this.active
            }
            
        },
        goToNext: function() {
            this.$emit('nextAction');
        }
    }
}
</script>


<style lang="scss" scoped>
    .disabled {
        cursor: not-allowed !important;
        label {
            pointer-events: none;    
        }
    }

    // We need to override the color here...
    .btn-success {
        background-color: rgb(40, 167, 69) !important;
    }
</style>